// extracted by mini-css-extract-plugin
export var confirmationHeader = "_x4-0";
export var confirmationIcon = "_x4-1";